import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col, Label, Input, FormGroup } from 'reactstrap';
import TextBox from '@components/TextBox/TextBox';

import MobileNav from '@components/Quoting/MobileNav/MobileNav';
import validator from 'validator';
import * as actions from '@store/actions';

const required = value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Please fill out this field.';
  }
};

const isEmail = value => {
  if (!validator.isEmail(value)) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Provide a valid email address.';
  }
};

const fieldValidator = {
  accountName: [required],
  contactEmail: [required, isEmail]
};

class Type extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountName: {
        value: props.accountName,
        visited: true,
        error: false
      },
      contactEmail: {
        value: props.contactEmail,
        visited: false,
        error: false
      }
    };
  }

  onInputChange = (name, value) => {
    const input = { ...this.state[name] };
    input.value = value;
    input.error = false;
    for (let i = 0; i < fieldValidator[name].length; i++) {
      input.visited = true;
      const validationMsg = fieldValidator[name][i](value);
      if (validationMsg !== undefined) {
        input.error = validationMsg;
      }
    }

    this.setState({ [name]: input });
  };

  onSubmit = () => {
    if (this.props.data.profile_ContractVersion === 2) {
      const formData = JSON.parse(JSON.stringify(this.state));
      let isValid = true;

      for (let key in formData) {
        formData[key].error = false;
        for (let i = 0; i < fieldValidator[key].length; i++) {
          formData[key].visited = true;
          const validationMsg = fieldValidator[key][i](formData[key].value);
          if (validationMsg !== undefined) {
            formData[key].error = validationMsg;
            isValid = false;
          }
        }
      }
      this.setState(formData);

      if (isValid) {
        this.props.setBookerInfo(
          this.state.accountName.value,
          this.state.contactEmail.value
        );
        this.props.nextClick();
      }
    } else {
      this.props.nextClick();
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.props.isMobile && (
          <MobileNav {...this.props} title={'Account Info'} />
        )}
        <TextBox header={this.props.isMobile ? '' : 'SuiteKey Member'}>
          <Row>
            {this.props.data.profile_ContractVersion !== 2 && (
              <Col md={12} lg={5}>
                <div className={'asap-bold color-red font-sm'}>
                  ACCOUNT INFO
                </div>
                <div
                  className={
                    'font-sm asap-medium ' +
                    (this.props.isMobile ? 'pb-3 ' : 'd-flex pl-4')
                  }
                >
                  <div className={'mr-2'}>Name:</div>
                  <div>
                    {this.props.data.FirstName} {this.props.data.LastName}
                  </div>
                </div>

                <div className={'asap-bold color-red font-sm'}>
                  LOGGED IN AS
                </div>
                <div
                  className={
                    'font-sm asap-medium ' +
                    (this.props.isMobile ? 'pb-3' : 'pl-4')
                  }
                >
                  {this.props.mail}
                </div>
              </Col>
            )}

            {this.props.data.profile_ContractVersion !== 2 ? (
              <Col md={12} lg={7}>
                <React.Fragment>
                  <div className={'asap-bold color-red font-sm'}>
                    CONTRACT INFO
                  </div>
                  <div
                    className={
                      'font-sm asap-medium ' +
                      (this.props.isMobile ? 'pb-3' : 'pl-4')
                    }
                  >
                    Select A Contract ID:
                    <br />
                    <input
                      type={'radio'}
                      defaultChecked={true}
                      className={'ml-1 mr-3'}
                    />{' '}
                    {this.props.data.profile_ContractID} (
                    {this.props.data.profile_ContractType})
                  </div>
                </React.Fragment>
              </Col>
            ) : (
              <Col md={12}>
                <React.Fragment>
                  <Row>
                    <Col xs={6}>
                      <FormGroup>
                        <Label>Account Name</Label>
                        <Input
                          value={this.state.accountName.value}
                          className={
                            this.state.accountName.visited &&
                            this.state.accountName.error !== false
                              ? 'is-invalid-input'
                              : ''
                          }
                          onChange={e =>
                            this.onInputChange(
                              'accountName',
                              e.currentTarget.value
                            )
                          }
                        />
                        {this.state.accountName.visited && (
                          <span className={'error'}>
                            {this.state.accountName.error}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col xs={6}>
                      <FormGroup>
                        <Label>Contact Email</Label>
                        <Input
                          value={this.state.contactEmail.value}
                          type={'email'}
                          className={
                            this.state.contactEmail.visited &&
                            this.state.contactEmail.error !== false
                              ? 'is-invalid-input'
                              : ''
                          }
                          onChange={e =>
                            this.onInputChange(
                              'contactEmail',
                              e.currentTarget.value
                            )
                          }
                        />
                        {this.state.contactEmail.visited && (
                          <span className={'error'}>
                            {this.state.contactEmail.error}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </React.Fragment>
              </Col>
            )}
          </Row>
        </TextBox>
        <button
          className={
            'btn btn-fullred ' +
            (this.props.isMobile ? 'd-block mx-auto' : 'mt-2 float-right')
          }
          onClick={this.onSubmit}
        >
          {this.props.data.profile_ContractVersion === 2
            ? 'REQUEST TRIP'
            : 'REQUEST QUOTE'}
        </button>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    accountName: state.flightInfo.accountName,
    contactEmail: state.flightInfo.contactEmail
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setBookerInfo: (accountName, contactEmail) =>
      dispatch(actions.quotingSetBookerInfo(accountName, contactEmail))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Type);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Type/Type.jsx